class OptionIDConverter {
    private readonly ID_ITEMS_DIVIDER = '/';

    public create(oddId: number, items: number[] = []): string {
        if (!Number.isInteger(oddId)) {
            throw new Error('Invalid oddId: must be an integer.');
        }

        const itemsString = items?.length ? `${this.ID_ITEMS_DIVIDER}${JSON.stringify(items)}` : '';

        return `${oddId}${itemsString}`;
    }

    public parse(optionDOMID: string): { oddId: number; items?: number[] } {
        const [oddIdStr, itemsIdsString] = optionDOMID.split(this.ID_ITEMS_DIVIDER);

        if (!oddIdStr || Number.isNaN(Number(oddIdStr))) {
            throw new Error('Invalid format: oddId is missing or not a number.');
        }

        let parsedItems: number[] = [];

        if (itemsIdsString) {
            try {
                parsedItems = JSON.parse(itemsIdsString);
            } catch {
                throw new Error('Invalid format: items is not a valid JSON array.');
            }
        }

        const oddId = Number(oddIdStr);

        return { oddId, items: parsedItems?.length ? parsedItems : undefined };
    }

    public hasOptionId(optionDOMID: string, optionId: string): boolean {
        return new RegExp(`^${optionId}(${this.ID_ITEMS_DIVIDER}|$)`).test(optionDOMID);
    }
}

export const optionIDConverter = new OptionIDConverter();
